import { render, staticRenderFns } from "./TwoFactorMethodSetup.vue?vue&type=template&id=8e439186&scoped=true"
import script from "./TwoFactorMethodSetup.vue?vue&type=script&lang=js"
export * from "./TwoFactorMethodSetup.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorMethodSetup.vue?vue&type=style&index=0&id=8e439186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e439186",
  null
  
)

export default component.exports